import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-file-upload-dialog',
  templateUrl: './file-upload-dialog.component.html',
  styleUrls: ['./file-upload-dialog.component.css']
})
export class FileUploadDialogComponent {
  selectedFile: File | null = null;
  targetPath: string = '/home/hh';
  uploading = false;

  constructor(
    public dialogRef: MatDialogRef<FileUploadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    const lastPath = localStorage.getItem('lastUploadTargetPath');
    if (lastPath) {
      this.targetPath = lastPath;
    }
  }

  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0] || null;
  }

  onUpload() {
    if (this.selectedFile && this.targetPath) {
      this.uploading = true;
      localStorage.setItem('lastUploadTargetPath', this.targetPath);
      this.dialogRef.close({ file: this.selectedFile, targetPath: this.targetPath });
    }
  }
}
